<template>
  <div>
    <md-dialog
      :md-active="showDialog"
      :md-backdrop-close="false"
      :md-esc-close="false"
    >
      <div class="encabezado text-center">
        <img src="../../isep/Tools/error.gif" alt="" class="gif" />
      </div>
      <div class="p-3 text-center">
        <h4>E R R O R!</h4>
        <p>{{ mensaje }}</p>
        <md-button
          class="md-primary buton-alert col-6"
          @click="showDialog = false"
          >Continuar</md-button
        >
      </div>
    </md-dialog>
  </div>
</template>
  
  <script>
export default {
  name: "DialogCustom",
  props: {
    showDialog: Boolean,
    mensaje: String,
  },
  data: () => ({
    // showDialog: false
  }),
};
</script>
  
  <style lang="scss" scoped>
.md-dialog /deep/.md-dialog-container {
  width: 400px;
  border-radius: 30px;
}
.buton-alert {
  background-color: #f83636;
  color: white !important;
}
.encabezado {
  background-color: #eb4141;
}
.gif {
  height: 4rem !important;
}
</style>